export const GlobalConfig = {
    PRIMARY_COLOR: 0x008080,  
    SECONDARY_COLOR: 0x2e2d2d, 
    FONT_COLOR: 0x00ffff, 
    BUTTON_COLOR:0x79DA07,
    BACKGROUND_COLOR: 0x000000,
    TANK_COLOR:0x008080,
    RTP:90,
    RTP_MAX_TURN:3,
    RTP_ADJESTMENT:20,
    BUTTON_TINT:0xd6d6d6,
    RECT_TINT:0x1f1f1f,
    FONT_FAMILY: 'Arial',
    FONT_SIZE_TITLE:'30px',
    FONT_SIZE_NORMAL:'12px',
    GAME_NAME:'AUTO POKER',
    MIN_FAKE_USER_DELAY: 1000, // 1 sec
    MAX_FAKE_USER_DELAY: 5000, // 5 sec
    START_USD:1000,
    SIZE_MULTI:1,
    SHAKE_EFF_Time:500,
    SHAKE_EFF_INT:0.001,
    

};